import React from 'react';
import { Box, useTheme } from '@mui/material';
import PearsanaLogo from '../../assets/images/pearsana-logo.svg';
import PearsanaLogoDark from '../../assets/images/pearsana-logo-dark.svg';
import PearsanaIcon from '../../assets/images/pearsana-icon.svg';
import PearsanaIconDark from '../../assets/images/pearsana-icon-dark.svg';

const Logo = ({ collapsed, height = '5rem' }: { collapsed?: boolean; height?: string }) => {
	const isDark = useTheme().palette.mode === 'dark';
	return (
		<Box height={height} overflow={'hidden'} display="flex" alignItems={'center'} justifyContent={'center'}>
			{collapsed ? (
				<img
					src={isDark ? PearsanaIconDark : PearsanaIcon}
					alt="Pearsana"
					style={{ height: '1.75rem', width: 'auto' }}
				/>
			) : (
				<img
					src={isDark ? PearsanaLogoDark : PearsanaLogo}
					alt="Pearsana"
					style={{ maxHeight: '2rem', height: 'auto', width: 'auto', maxWidth: '100%' }}
				/>
			)}
		</Box>
	);
};

export default Logo;
